module.exports = __webpack_public_path__ + "static/media/IMG_1404.112e0a86.JPG";